import type DxfArrayScanner from '../DxfArrayScanner';
import { ScannerGroup } from '../DxfArrayScanner';
import { ensureHandle } from '../shared';
import isMatched from '../shared/isMatched';
import ThreeDFaceEntityParser from './3dface/parser';
import ArcEntityParser from './arc/parser';
import AttDefEntityParser from './attdef/parser';
import AttributeEntityParser from './attribute/parser';
import CircleEntityParser from './circle/parser';
import Dimension from './dimension';
import EllipseEntityParser from './ellipse/parser';
import InsertEntityParser from './insert/parser';
import LeaderEntityParser from './leader/parser';
import LineEntityParser from './line/parser';
import LWPolylineParser from './lwpolyline/parser';
import { MTextEntityParser } from './mtext/parser';
import PointEntityParser from './point/parser';
import PolylineParser from './polyline/parser';
import SectionEntityParser from './section/parser';
import SolidEntityParser from './solid/parser';
import SplineEntityParser from './spline/parser';
import { TextEntityParser } from './text';
import { HatchEntityParser } from './hatch';
import ViewportParser from './viewport';
import { CommonDxfEntity } from './shared';

const Parsers = Object.fromEntries(
  [
    ThreeDFaceEntityParser,
    ArcEntityParser,
    AttDefEntityParser,
    AttributeEntityParser,
    CircleEntityParser,
    Dimension,
    EllipseEntityParser,
    InsertEntityParser,
    LeaderEntityParser,
    LineEntityParser,
    LWPolylineParser,
    MTextEntityParser,
    PointEntityParser,
    PolylineParser,
    SectionEntityParser,
    SolidEntityParser,
    SplineEntityParser,
    TextEntityParser,
    HatchEntityParser,
    ViewportParser,
  ].map((ParserClass) => [ParserClass.ForEntityName, new ParserClass()]),
);

/**
 * Is called after the parser first reads the 0:ENTITIES group. The scanner
 * should be on the start of the first entity already.
 */
export default function parseEntities(
  curr: ScannerGroup,
  scanner: DxfArrayScanner,
): CommonDxfEntity[] {
  const entities: any[] = [];

  let current = curr;
  while (!isMatched(current, 0, 'EOF')) {
    if (current.code === 0) {
      // BLOCK 섹션 안에 ENTITY 섹션이 있을 수도 있고
      // ENTITY 섹션만 따로 있을 수도 있음
      // BLOCK 섹션 안에 들어있는 ENTITY는 ENDBLK으로 끝남
      // ENTITY 섹션만 끝나면 ENDSEC으로 끝남
      if (current.value === 'ENDBLK' || current.value === 'ENDSEC') {
        scanner.rewind();
        break;
      }

      const handler = Parsers[current.value];
      if (handler) {
        const entityType = current.value;
        current = scanner.next();

        // The parsers are not consistent. Some parsers have a static `parseEntity` method,
        // and others have an instance method.
        let entity;
        if (typeof (handler as any).parseEntity === 'function') {
          entity = (handler as any).parseEntity(scanner, current);
        } else {
          entity = (handler.constructor as any).parseEntity(scanner, current);
        }
        entity.type = entityType;
        ensureHandle(entity);
        entities.push(entity);
      }
    }

    current = scanner.next();
  }
  return entities;
}
